import React from 'react';

const CalendarIcon: React.FC<{size?: number; color?: string}> = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="14" height="13" rx="2" stroke={color} strokeWidth="1.8"/>
    <path d="M6 2V6M14 2V6M3 8H17" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

export default CalendarIcon;

